import React, {createContext, useState} from "react";
import { API, defaultError, config, closeSession } from "../config";
import axios from "axios";
import useSWR from "swr";

const MyQuestionsContext = createContext();

const MyQuestionsProvider = ({ children }) => {
    const [error, setError] = useState({"error": false, "message": ""});
    const [question, setQuestion] = useState({"questionTitle": "", "questionAnswer": ""});
    const [questions, setQuestions] = useState([])
    const [sorters, setSorters] = useState({"sorter": "date", "order": "desc"});
    const [page, setPage] = useState(0);
    const [pageAdmin, setPageAdmin] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const fetcher = () => axios.get(`${API}/questions/getallquestions/${sorters.sorter}/${sorters.order}/${page}`).then(res => {
        setMaxPage(res.data.maxPage);
        return res.data.response
    });

    function useQuestions () {
        const {data, error} = useSWR(`${API}/questions/getallquestions/${sorters.sorter}/${sorters.order}/${page}`, fetcher);
        return {
            questions: data,
            isLoading: !error && !data,
            isError: error
        }
    }

    const getQuestionsAdmin = async () => {
        setError({"error": false, "message": ""});
        setLoading(true);
        await axios.get(`${API}/questions/questions/${pageAdmin}`, config).then(res => {
            if(res.data.error){
                if(res.data.status == "400-1"){
                    closeSession();
                }
                setLoading(false)
                setError({"error": true, "message": res.data.response});
                return;    
            }
            setMaxPage(res.data.maxPage);
            setQuestions(res.data.response);
        }).catch(err=>{
            setError(defaultError);
        })
        setLoading(false);  
    }

    const addQuestion = async (data)=>{
        setLoading(true);
        var formData = new FormData();
        formData.append("questionTitle", data.questionTitle);
        formData.append("questionAnswer", data.questionAnswer);

        config.headers["Content-Type"] = "multipart/form-data";
        try{
            const res = await axios.post(`${API}/questions/addquestion`, formData, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getQuestionsAdmin();
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const updateQuestion = async (data, questionId)=>{
        setLoading(true);
        var formData = new FormData();
        formData.append("questionTitle", data.questionTitle);
        formData.append("questionAnswer", data.questionAnswer);

        config.headers["Content-Type"] = "multipart/form-data";
        try{
            const res = await axios.put(`${API}/questions/updatequestion/${questionId}`, formData, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getQuestionsAdmin();
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const changeQuestionVisibility = async(questionId) => {
        try{
            const res = await axios.put(`${API}/questions/changequestionvisibility/${questionId}`, {}, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getQuestionsAdmin();
            }
            return res.data;
        } catch(err){
            return defaultError;
        }
    }

    const deleteQuestion = async(questionId) => {
        setLoading(true);
        try{
            const res = await axios.delete(`${API}/questions/deletequestion/${questionId}`, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getQuestionsAdmin();
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    return (
        <MyQuestionsContext.Provider value={{
            error,
            question,
            setQuestion,
            sorters,
            setSorters,
            maxPage,
            setPage,
            useQuestions,
            setPageAdmin,
            pageAdmin, 
            changeQuestionVisibility,
            getQuestionsAdmin,
            questions,
            loading, 
            deleteQuestion,
            addQuestion,
            setError,
            updateQuestion
        }}>
            {children}
        </MyQuestionsContext.Provider>
    );
}

export { MyQuestionsProvider };
export default MyQuestionsContext;